module.exports = __webpack_public_path__ + "img/tip_bg.e1dad590.png";